import { Card, Grid, Typography, Box } from "@mui/material";
import ArrowForwardOutlinedIcon from '@mui/icons-material/ArrowForwardOutlined';
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { update } from "../../../slice/jobSlice";
import { LuCalendarDays } from "react-icons/lu";
import SyncProblemIcon from '@mui/icons-material/SyncProblem';

const AddJobType = () => {
  const { jobData } = useSelector(state => state.job);

  const [selectedServiceType, setSelectedServiceType] = useState("One Time");
  const dispatch = useDispatch();

  useEffect(() => {
    if (jobData?.SERVICE_TYPE)
      setSelectedServiceType(jobData?.SERVICE_TYPE)
  }, [jobData?.SERVICE_TYPE])

  const onSubmitNext = (val) => {
    setSelectedServiceType(val);
    dispatch(update({ SERVICE_TYPE: val }));
    dispatch(update({ JOB_SERVICE_WITH_DAY_TIME: [] }));
  };

  return (
    <>
      <Grid container alignItems="center" spacing={1} justifyContent="space-around" px={1.2} pb={3}>
        <Grid item xs={12} sm={12} mt={3}>
          <Typography variant="h3" className="about-texts">
            How often do you need this service?
          </Typography>
        </Grid>


        <Grid container spacing={2} mt={1}>
          <Grid item lg={6} onClick={() => onSubmitNext("One Time")}>
            <Card
              style={{
                background: selectedServiceType === "One Time" ? "#6ebe44" : "#f5f5f5",
                cursor: "pointer",
                padding: "7.41px"
              }}
            >
              <Box display="flex" justifyContent="center">
                <LuCalendarDays style={{ fontSize: "30px", color: selectedServiceType === "One Time" ? "#fff" : "#6ebe44", marginTop: 2 }} />
              </Box>

              <Grid p={4} style={{ display: "flex", justifyContent: "space-between" }}>
                <Typography
                  variant="h3"
                  //   className="about-text"
                  style={{
                    color: selectedServiceType === "One Time" ? "#fff" : "#000",
                    fontSize: "18px",
                  }}
                >
                  One Time
                </Typography>
                <ArrowForwardOutlinedIcon style={{ color: selectedServiceType === "One Time" ? "#fff" : "#6ebe44", marginTop: -2 }} />
              </Grid>
            </Card>
          </Grid>

          <Grid item lg={6} onClick={() => onSubmitNext("Recurring")}>
            <Card
              style={{
                background: selectedServiceType === "Recurring" ? "#6ebe44" : "#f5f5f5",
                cursor: "pointer",
                padding: "7.41px"
              }}
            >
              <Box display="flex" justifyContent="center">
                <SyncProblemIcon style={{ fontSize: "30px", color: selectedServiceType === "Recurring" ? "#fff" : "#6ebe44", marginTop: 2 }} />
              </Box>

              <Grid p={4} style={{ display: "flex", justifyContent: "space-between" }}>
                <Typography
                  variant="h3"
                  //   className="about-text"
                  style={{
                    color: selectedServiceType === "Recurring" ? "#fff" : "#000",
                    fontSize: "18px",

                  }}
                >
                  Recurring
                </Typography>
                <ArrowForwardOutlinedIcon style={{ color: selectedServiceType === "Recurring" ? "#fff" : "#6ebe44", marginTop: -2 }} />
              </Grid>
            </Card>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default AddJobType;
